export default "__VITE_ASSET__qqYfyqqa__$_?component__"